module.exports = __webpack_public_path__ + "static/media/assessment.042f3b4a.png";